import React, { useEffect } from "react";
import { InjectedFormProps, initialize } from "redux-form";
import { MoneyTransferPage } from "../../types/moneyTransfer";
import { COMMON } from "../../constants/localization";
import { ACTION_DISPLAY_TYPES } from "../../constants/enums";
import { useDispatch } from "react-redux";

import ActionLink from "../../components/Common/ActionLink";
import DynamicForm from "../../components/MoneyTransfer/DynamicForm";
import Action from "../../components/Common/Action";
import DisplaySection from "../../components/MoneyTransfer/DisplaySection";
import ApiErrorModal from "../../components/Common/Modals/ApiErrorModal";

type CustomProps = {
  pageData: MoneyTransferPage;
  formName: string;
  onBack: () => void;
  onSubmit: (values: { [key: string]: any; }) => Promise<void>;
}

const DynamicFormWrapper: React.FC<CustomProps & InjectedFormProps<{}, CustomProps>> = ({ pageData, formName, onBack, onSubmit, handleSubmit, error, valid, submitting, submitFailed, invalid }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);

    const initialValues = {};
    pageData.sections.forEach(section => {
      section.fields.forEach(field => {
        initialValues[field.serviceProviderFieldId] = field.value
      })
    });

    dispatch(initialize(formName, initialValues));
  }, []);

  const renderFormErrors = (errors) => {
    if (errors && errors.length > 0) {
      return (
        <ul className="bullet-list error-list">
          {errors.map((error) => (
            <li key={error?.errorCode}>{error.errorMessage}</li>
          ))}
        </ul>
      );
    }
  }

  return (
    <div>
      {pageData &&
        <p className="large spacing-bottom-small">
          {pageData.subTitle}
        </p>
      }

      {pageData &&
        <DisplaySection sections={pageData.displaySections} />
      }

      <form onSubmit={handleSubmit(onSubmit)}>
        {renderFormErrors(error)}

        {pageData && (
          <DynamicForm
            fieldCategory={pageData}
            formName={formName}
            newDynamicFormWrapper={true}
          />
        )}

        <div className="row navRow">
          <div className="col-xs-12 col-sm-6 two">
            <ActionLink clickFunc={onBack} classes="mt-link">
              <div className="glyphicon glyphicon-menu-left link_icon"></div>
              {COMMON.BACK}
            </ActionLink>
          </div>
          <div className="col-xs-12 col-sm-6 one">
            <Action
              type="submit"
              loading={submitting}
              disabled={
                invalid
              }
              title={COMMON.NEXT}
              displayType={ACTION_DISPLAY_TYPES.PRIMARY}
            />
          </div>
        </div>

      </form>

      <ApiErrorModal />
    </div>
  );
}

export default DynamicFormWrapper;